var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useGetVantageCreditScore } from "../const/syfApiQueries";
import { useVantageContext } from "../context/vantageContext";
import { useConfig } from "../hooks/useConfig";
import useVantageEligibility from "../hooks/useVantageEligibility";
import VantageLoader from "./atoms/VantageLoader";
import CreditScorePage from "./templates/CreditScore";
import ErrorPage from "./templates/ErrorPage";
import NoCreditScorePage from "./templates/NoCreditScore";
var Vantage = function () {
    var config = useConfig();
    var renderWrapper = useRef(null);
    var i18n = useTranslation().i18n;
    var shouldShowErrorPage = useVantageContext().state.shouldShowErrorPage;
    var _a = useVantageEligibility(), isLoading = _a.isLoading, error = _a.error, leadingEnrolledAccount = _a.leadingEnrolledAccount, currentEnrolledAccounts = _a.currentEnrolledAccounts, accountToBeEnrolled = _a.accountToBeEnrolled;
    var vantageScore = useGetVantageCreditScore(leadingEnrolledAccount);
    useEffect(function () {
        i18n.changeLanguage(config.lang);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config.lang]);
    if (error || vantageScore.error || shouldShowErrorPage) {
        return _jsx(ErrorPage, {});
    }
    if (!renderWrapper.current && (isLoading || vantageScore.isFetching)) {
        return _jsx(VantageLoader, {});
    }
    if (!isLoading && !leadingEnrolledAccount && !accountToBeEnrolled) {
        return (_jsx(ErrorPage, { hasDescription: false, title: "errorPage.creditScoreNotAvailable", subtitle: "errorPage.anyAccountsQualify" }));
    }
    if (!leadingEnrolledAccount && accountToBeEnrolled) {
        return (_jsx("div", __assign({ ref: renderWrapper }, { children: _jsx(NoCreditScorePage, { accountToEnroll: accountToBeEnrolled }) })));
    }
    return (_jsx("div", __assign({ ref: renderWrapper }, { children: _jsx(CreditScorePage, { vantageScoreData: vantageScore.data, vantageEnrolledAccounts: currentEnrolledAccounts }) })));
};
export default Vantage;
